export default __webpack_public_path__ + "static/select.light-87df778493808a55553dd81ec254a4275745d5be547bd412faf1465ac8bd2bcb.png";